/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsAssignedReviewIssueNewRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.assigned.review.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsAssignedReviewIssueNewRoute);
